export default __webpack_public_path__ + "static/media/memo_doc_png.af3b7cb8.svg";